export default __webpack_public_path__ + "static/media/tabCard.2853d4dc.jpg";